import { useTranslation } from 'zf-web-components';
import styles from './index.module.less';
import type { ReactElement } from 'react';

export function PrivacyPolicy(): ReactElement {
  const [t] = useTranslation();

  return (
    <div className={styles.statementWrap}>
      <span className={styles.statement}>
        {t('登录即代表同意')}&nbsp;
        <a
          className={styles.lightText}
          target='_black'
          href={'./agreement'}
        >
          {t('用户协议')}
        </a>
        &nbsp;{t('和')}&nbsp;
        <a
          className={styles.lightText}
          target='_black'
          href={'./privacy'}
        >
          {t('隐私声明')}
        </a>
      </span>
    </div>
  );
}
